export default "__VITE_ASSET__41c2bda3__"